"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValueInEnum = void 0;
const isValueInEnum = (e, u) => {
    if (!u)
        return false;
    return Object.values(e).includes(u);
};
exports.isValueInEnum = isValueInEnum;
//# sourceMappingURL=isValueInEnum.js.map